import Typography from '@mui/material/Typography';
import styled from '@emotion/styled';
import { colors } from '../tokens';

/**
 * ProfitLossText — displays profit/loss values with semantic coloring.
 * Replaces repeated ternary color patterns:
 *   color: value.includes('-') ? '#F94F59' : '#50AD20'
 *
 * Usage:
 *   <ProfitLossText isLoss={value < 0}>+2.45%</ProfitLossText>
 *
 * Props:
 *   isLoss: boolean — when true, renders in error.light (red); otherwise success green
 */
const ProfitLossText = styled(Typography)(({ isLoss }) => ({
  color: isLoss ? colors.error.light : colors.secondary.main,
}));

export default ProfitLossText;
